import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';
import { BreadcrumbService } from '@ui-core/services/breadcrumb/breadcrumb.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent
// implements OnInit 
{

  @Output() changeRoute = new EventEmitter<string>();
  @Input() baseRoute = '/';

  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(
    breadcrumbService: BreadcrumbService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }

  // ngOnInit(): void {
  // }

  public handleRouteChange(relativeRoute: string) {
    this.router.navigate([relativeRoute]);
  }
}